module.exports = __webpack_public_path__ + "img/mertyed-logo.097f840e.svg";